import PropTypes from "prop-types";
import "@streamo/shared/fonts/material-design-iconic-font.min.css";

const Layout = ({ children }) => <div className="wrappper">{children}</div>;
Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
